<template>
    <v-row wrap justify="center" class="ma-4">
        <v-col cols="12" sm="12" md="6" lg="4" v-for="project in projects" :key="project.name">
          <v-hover v-slot="{ hover }">
            <v-card flat outlined class="text-center my-4 rounded-xl">
              <v-img aspect-ratio="1" class="justify-center" :src="project.image">
                <v-expand-transition>
                  <v-row  v-if="hover" align="center" justify="center" class="transition-fast-in-fast-out v-card--reveal  font-weight-bold" style="height: 100%; opacity: 0.8; background-color: #082543;  background-image: linear-gradient(to bottom right, #082543, grey);" >
                    <p class="mt-4 font-weight-bold" v-text="project.name" />
                    <v-btn text :class="{'mt-5': $vuetify.breakpoint.smAndDown}" @click="openLink(project.link)">
                      <v-icon size="50">mdi-eye</v-icon>
                    </v-btn>
                  </v-row>
                </v-expand-transition>
              </v-img>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
</template>

<script>
export default {
  data(){
    return{
      projects: [
        {name: "Flutter Ecommerce UI Kit", image: "/Flutter ecommerce.png",link:"https://codecanyon.net/item/flutter-ecommerce-ui-kit/29910272"},
        {name: "Catcheep Mobile Game", image: "/Catcheep.png",link:"https://github.com/JetLightStudio/Catcheep"},
        {name: "Spotify UI Clone Vue js ", image: "/spotify.png",link:"https://github.com/JetLightStudio/spotify-UI-clone-vuejs"},
        {name: "Augmented Reality Demo Unity", image: "/AR.png",link:"https://github.com/JetLightStudio/Ar-Running-App"},
        {name: "Telegram UI Clone JavaFX", image: "/telegram.png",link:"https://github.com/JetLightStudio/TelegramClone"},
        {name: "Postman UI Clone Vue js", image: "/postman.jpg",link:"https://github.com/JetLightStudio/Postman-UI-Clone"}
      ],
    }
  },
  methods:{
    openLink(link){
      window.open(link, "_blank")
    }
  }
}
</script>